<template>
    <accordion-input :accordion="accordion" :spacing="spacing" :open="open">
        <template #label>
            <div class="font-medium text-gray-600">{{ label }}</div>
        </template>
        <template #content>
            <small v-if="instruction" class="block mb-3 text-gray-500 label text-muted">
                {{ instruction }}
            </small>

            <div class="mt-1">
                <input
                    v-if="textarea === undefined || textarea === false"
                    type="text"
                    :placeholder="placeholder"
                    class="block w-full px-4 py-2 text-base bg-white border border-gray-300 rounded focus:border-indigo-500 focus:ring-indigo-500"
                    @blur="setValue()"
                    v-model="input"
                />

                <textarea
                    v-else
                    :placeholder="placeholder"
                    rows="4"
                    class="block w-full px-4 py-2 text-base bg-white border border-gray-300 rounded focus:border-indigo-500 focus:ring-indigo-500"
                    @blur="setValue()"
                    v-model="input"
                />
            </div>
        </template>
    </accordion-input>
</template>

<script>
import AccordionInput from '@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/helpers/Input';

export default {
    components: {
        AccordionInput,
    },

    data() {
        return {
            isOpen: this.open || false,
            input: this.options[this.optionsProperty] ?? '',
        };
    },

    props: {
        label: {
            type: String,
            required: true,
        },

        instruction: {
            type: String,
        },

        spacing: {
            horizontal: {
                type: Boolean,
                default: true,
            },
            vertical: {
                type: Boolean,
                default: true,
            },
        },

        accordion: {
            type: Boolean,
            default: true,
        },

        open: {
            type: Boolean,
            default: null,
        },

        options: {
            type: Object,
            required: true,
        },

        optionsProperty: {
            required: true,
        },

        placeholder: {
            type: String,
            required: false,
        },

        textarea: {
            type: Boolean,
            required: false,
        },
    },

    methods: {
        setValue() {
            // Set in options.
            this.$set(this.options, this.optionsProperty, this.input);

            // Emit for whoever wants to know.
            this.$emit('valueChange');
        },
    },
};
</script>
